export default {
    stamp: {
        smaller: "Stempel verkleinern",
        greater: "Stempel vergrößern",
        result : "Dokument mit Stempel",
        size   : {
            "3": "Groß",
            "2": "Normal",
            "1": "Klein",
            "0": "Sehr klein",
        },
        upload: {
            text: {
                save : "Text speichern",
                image: "Vorschau"
            },
            error: {
                type: {
                    title  : "Ungültige Datei: {0}",
                    message: "Als Stempel für PDF Dateien können nur Bilddateien vom Typ PNG, JPEG oder GIF verwendet werden."
                }
            }
        },
    }
}